import { useEffect } from 'react'

// Rota inválida alcançada por navegação interna. Acesso direto nem chega aqui:
// o Apache só entrega o index.html para as rotas reais do app e devolve 404 no
// resto, servindo /erro.html (ver docs/htaccess-servidor.md).
//
// Aponta para o mesmo arquivo estático em vez de reimplementar a tela em React:
// assim existe uma implementação visual só, compartilhada com o 404/403/500 do
// servidor. Antes daqui vivia um <Navigate to="/">, que jogava o visitante na
// home sem explicar nada e ainda respondia 200 em URL inexistente - o "soft
// 404" que o Google contabiliza como página de baixa qualidade.
export const ERROR_PAGE_URL = '/erro.html'

const PaginaErro = () => {
  useEffect(() => {
    // replace, não assign: a URL quebrada não fica no histórico, então o botão
    // voltar do navegador não devolve o visitante para o erro.
    window.location.replace(ERROR_PAGE_URL)
  }, [])

  return null
}

export default PaginaErro
